import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { Subject } from 'rxjs';
import { AllInterventionDal } from '../dal/all-intervention.dal';
import { AllIntervention } from '../models/all-intervention.model';

@Injectable({
  providedIn: 'root',
})
export class AllInterventionService {
  public interventionChanged = new Subject<AllIntervention>();

  constructor(private interventionDal: AllInterventionDal) {}

  getAllInterventions(filterName: string, limit: number, page: number): Observable<any> {
    return this.interventionDal.getAllInterventions(filterName, limit, page);
  }

  addIntervention(intervention: AllIntervention): Observable<AllIntervention> {
    return this.interventionDal.addIntervention(intervention);
  }

  clear() {
    this.interventionChanged.complete();
    this.interventionChanged = new Subject<AllIntervention>();
  }
}
